<template>
  <div>
    <video id="myVideo" class="hide-progress-bar" :src="videoUrl" v-if="videoUrl" autoplay @ended="() => changeFile('1', true)" />
    <div v-else>暂无视频播放</div>
  </div>
</template>

<script>
import mqtt from 'mqtt';
import axios from 'axios';

import { Message, MessageBox } from 'element-ui';

import { defineComponent, reactive, onBeforeUnmount, onMounted, watch, unref } from 'vue';

export default defineComponent({
  name: 'MqttConnect',
  setup () {
    onBeforeUnmount(() => {
      destroyConnection();
    });

    onMounted(() => {
      createConnection();
      changeFile('1')
    });

    function deobfuscate(str, shift = 3) {
      return obfuscate(str, 26 - shift);
    }

    const data = reactive({
      connection: {
        host: '',
        port: null,
        endpoint: '/api/mqtt',
        clean: true, // 保留会话
        connectTimeout: 4000, // 超时时间
        // 认证信息
        clientId: '',
        username: '',
        password: '',
      },
      receiveNews: '',
      qosList: [
        { label: 0, value: 0 },
        { label: 1, value: 1 },
        { label: 2, value: 2 },
      ],
      client: {
        connected: false,
      },
      subscribeSuccess: false,
      subscription: ['video-change'],
      videoUrl: '',
      videoUrlPrefix: 'https://juyouqi.oss-cn-beijing.aliyuncs.com/media/video-change/',
      tryChangeFile: null,
    });

    const checkURL = async (url) => {
      return await axios.head(url, {
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Access-Control-Allow-Methods': 'HEAD',
        },
      })
        .then(() => {
          return true;
        })
        .catch((e) => {
          console.log(e)
          return false;
        });
    };

    const changeFile = async (message, endChange = false) => {
      if (data.tryChangeFile) {
        clearInterval(data.tryChangeFile)
        data.tryChangeFile = null
      }

      let url = data.videoUrlPrefix + message + '.mp4';

      if (url == data.videoUrl && endChange == true) {
        let myVideo = document.getElementById('myVideo');
        if (myVideo) {
          myVideo.play();
          return;
        }
      }

      let checkFile = await checkURL(url);
      if (checkFile) {
        let myVideo = document.getElementById('myVideo');
        if (!myVideo) {

          MessageBox.alert('请点击确认开始播放视频', {
            confirmButtonText: '确定',
            callback: action => {
              console.log(action)

              data.videoUrl = url;

              let count = 0
              data.tryChangeFile = setInterval(() => {
                count++
                myVideo = document.getElementById('myVideo');

                if (myVideo) {
                  if (data.tryChangeFile) {
                    clearInterval(data.tryChangeFile)
                  }
                  var isFullscreen = document.fullscreenElement
                  if (!isFullscreen) {
                    myVideo.requestFullscreen().catch(err => {
                      console.error(err);
                    });
                  }

                  myVideo.play();
                } else {
                  if (count > 60) {
                    if (data.tryChangeFile) {
                      clearInterval(data.tryChangeFile)
                    }
                  }
                }
              }, 1000);
            }
          });
        } else {
          if (!myVideo.paused) {
            myVideo.pause();
          }

          data.videoUrl = url;

          var isFullscreen = document.fullscreenElement
          if (!isFullscreen) {
            myVideo.requestFullscreen().catch(err => {
              console.error(err);
            });
          }

          myVideo.play();
        }
      } else {
        Message.warning('文件不存在')
      }
    }

    data.changeFile = changeFile;

    // 创建连接
    const createConnection = () => {
      data.connection.host = 'mqtt.jyq.pub';
      data.connection.username = deobfuscate('178EIEII00D40I4198:8I:H0:6F:F2:44&jjlv100000006epk');
      data.connection.password = deobfuscate('aBSCM9RJnk480eZ2');
      data.connection.port = 443;
      data.connection.clientId = 'video-client-' + Math.random() * 100000;
      const { host, port, endpoint, ...options } = data.connection;
      let connectUrl;
      if (window.location.href.indexOf('https') !== -1) {
        connectUrl = `wss://${host}:${port}${endpoint}`;
      } else {
        connectUrl = `wss://${host}:${port}${endpoint}`;
      }
      data.client = mqtt.connect(connectUrl, options);
      data.client.on('connect', () => {
        console.log('Connection succeeded!');
      });
      data.client.on('error', (error) => {
        console.log('Connection failed', error);
      });
      data.client.on('message', async (topic, message) => {
        if (message.toString()) {
          console.log('getMessage', topic, JSON.parse(message.toString()));

          changeFile(message);
        }
      });
      data.subscription.forEach((item) => {
        doSubscribe(item, 0);
      });
    };

    // 订阅主题
    const doSubscribe = (topic, qos) => {
      data.client.subscribe(topic, { qos }, (error, res) => {
        if (error) {
          console.log('Subscribe to topics error', error);
          return;
        }
        data.subscribeSuccess = true;
        console.log('Subscribe to topics res', res);
      });
    };
    // 取消订阅
    const doUnSubscribe = (topic) => {
      data.client.unsubscribe(topic, (error) => {
        if (error) {
          console.log('Unsubscribe error', error);
        }
      });
    };
    // 断开连接
    const destroyConnection = () => {
      if (data.client.connected) {
        try {
          data.client.end();
          data.client = {
            connected: false,
          };
          console.log('Successfully disconnected!');
        } catch (error) {
          console.log('Disconnect failed', error.toString());
        }
      }
    };

    function obfuscate(str, shift = 3) {
      return str.split('').map(c => {
        // 只处理英文字符
        if (c.match(/[a-zA-Z]/)) {
          const charCode = c.charCodeAt(0);
          const base = charCode >= 65 && charCode <= 90 ? 65 : 97; // 确定是大写还是小写字母的基准
          return String.fromCharCode((charCode - base + shift) % 26 + base);
        }
        return c; // 非字母字符保持不变
      }).join('');
    }

    watch(
      () => unref(data).subscription,
      (subscription, old) => {
        old.forEach((item) => {
          doUnSubscribe(item);
        });
        setTimeout(() => {
          subscription.forEach((item) => {
            doSubscribe(item, 0);
          });
        }, 300);
      }
    );

    return data
  },
});
</script>

<style scoped>
.hide-progress-bar::-webkit-media-controls-timeline {
  display: none;
}

.hide-progress-bar::-webkit-media-controls {
  display: none;
}

.hide-progress-bar::-moz-progress-bar {
  display: none;
}

.hide-progress-bar::-ms-track {
  display: none;
}
</style>